module.exports = __webpack_public_path__ + "static/media/1.c9d5f56b.jpg";